import api from "../api";

// Get email transactions by client
export const getEmailTransactionsByClient = (clientId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `email-transactions/client/${clientId}`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 20,
      emailType: params.emailType,
      status: params.status,
    },
  });
};

// Get email transactions by agency
export const getEmailTransactionsByAgency = (agencyId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `email-transactions/agency/${agencyId}`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 20,
      emailType: params.emailType,
      status: params.status,
    },
  });
};

// Get single email transaction by ID
export const getEmailTransactionById = (id) => {
  return api.getApi().get(api.getBaseUrl() + `email-transactions/${id}`);
};

// Get mail send operations
export const getMailSendOperations = (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "email-transactions/operations/list", {
    params: {
      page: params.page || 1,
      limit: params.limit || 20,
      filter: params.filter,
    },
  });
};

// Retry failed email
export const retryEmail = (id) => {
  return api.getApi().post(api.getBaseUrl() + `email-transactions/${id}/retry`);
};

// Bulk retry failed emails
export const bulkRetryEmails = (ids) => {
  return api.getApi().post(api.getBaseUrl() + "email-transactions/bulk-retry", { ids });
};

// Get email statistics
export const getEmailStatistics = (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "email-transactions/statistics/summary", {
    params: {
      startDate: params.startDate,
      endDate: params.endDate,
      clientId: params.clientId,
      agencyId: params.agencyId,
    },
  });
};

// Get email queue status
export const getEmailQueueStatus = () => {
  return api.getApi().get(api.getBaseUrl() + "email-queue/status");
};

// Trigger queue processing
export const processEmailQueue = () => {
  return api.getApi().post(api.getBaseUrl() + "email-queue/process");
};

// Clear completed queue items
export const clearCompletedQueueItems = (olderThanDays = 7) => {
  return api.getApi().post(api.getBaseUrl() + "email-queue/clear-completed", { olderThanDays });
};
